import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/leave/v1`;

export function getMany({
  offset = 0,
  limit = 15,
  search = "",
  status,
  rangFilter = "",
}) {
  let leaveUrl = `${url}/lists?offset=${offset}&limit=${limit}&search=${search}&rangFilter=${rangFilter}`;

  if (status) leaveUrl += `&status=${status}`;

  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: leaveUrl,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getManyReport({
  offset = 0,
  limit = 15,
  employeeId = "",
  date = "",
  isExport = false,
}) {
  let leaveUrl = `${url}/lists/report?offset=${offset}&limit=${limit}&isExport=${isExport}&rangFilter=${date}&employeeId=${employeeId}`;

  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: leaveUrl,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}



export function getOne(id) {
  const result = axios({
    method: "GET",
    url: `${url}/detail/${id}`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getNumberOfDay(startDate, endDate,startShift,endShift, leaveType) {
  const result = axios({
    method: "GET",
    url: `${url}/number_of_day?startDate=${startDate}&endDate=${endDate}&fromDateType=${startShift}&toDateType=${endShift}&leaveType=${leaveType}`,
    headers: getHeaders(),
  });
  
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getRounedNumberOfDayMaternityLeave(startDate, endDate, leaveType) {
  const result = axios({
    method: "GET",
    url: `${url}/maternity/number_of_day?startDate=${startDate}&endDate=${endDate}&leaveType=${leaveType}`,
    headers: getHeaders(),
  });
  
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getRecentlyPaternityLeave() {
  const result = axios({
    method: "GET",
    url: `${url}/recently_paternity_leave`,
    headers: getHeaders(),
  });
  
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function insertNewRecord(data) {
  return axios({
      method: 'POST',
      url: `${url}/request`,
      headers: getHeaders(),
      data
  });
}

export function updateRecordById(id, dataToUpdate) {
  return axios({
    method: "PUT",
    url: `${url}/update/${id}`,
    headers: getHeaders(),
    data: dataToUpdate,
  });
}

export function updateStatus(data) {
  return axios({
    method: "PUT",
    url: `${url}/approve`,
    headers: getHeaders(),
    data,
  });
}

export function cancelApprovedLeave(id) {
  return axios({
    method: "PUT",
    url: `${url}/cancel/${id}`,
    headers: getHeaders(),
  });
}

export function insertNewDayoff(data) {
  return axios({
      method: "POST",
      url: `${url}/dayoff`,
      headers: getHeaders(),
      data
  });
}

export function deleteDayoffById(id) {
  return axios({
      method: "DELETE",
      url: `${url}/dayoff/${id}`,
      headers: getHeaders()
  });
}
